// extracted by mini-css-extract-plugin
export default {"wrapper":"Z3-z","play":"_3-z"};